/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Device } from '../models/device';
import { SiteTypeWithActivityPlan } from '../models/site-type-with-activity-plan';
@Injectable({
  providedIn: 'root',
})
class FieldAppService extends __BaseService {
  static readonly FieldAppOnboardDevicePath = '/api/FieldApp/OnboardDevice';
  static readonly FieldAppGetAllSiteTypesWithActivityTypesPath = '/api/FieldApp/GetAllSiteTypesWithActivityTypes';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `FieldAppService.FieldAppOnboardDeviceParams` containing the following parameters:
   *
   * - `securityToken`:
   *
   * - `PurchasedTime`:
   *
   * - `ManufacturerModelId`:
   *
   * - `Identifier`:
   *
   * - `CustomerId`:
   */
  FieldAppOnboardDeviceResponse(params: FieldAppService.FieldAppOnboardDeviceParams): __Observable<__StrictHttpResponse<Device>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.securityToken != null) __headers = __headers.set('securityToken', params.securityToken.toString());
    if (params.PurchasedTime != null) __params = __params.set('PurchasedTime', params.PurchasedTime.toString());
    if (params.ManufacturerModelId != null) __params = __params.set('ManufacturerModelId', params.ManufacturerModelId.toString());
    if (params.Identifier != null) __params = __params.set('Identifier', params.Identifier.toString());
    if (params.CustomerId != null) __params = __params.set('CustomerId', params.CustomerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FieldApp/OnboardDevice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Device>;
      })
    );
  }
  /**
   * @param params The `FieldAppService.FieldAppOnboardDeviceParams` containing the following parameters:
   *
   * - `securityToken`:
   *
   * - `PurchasedTime`:
   *
   * - `ManufacturerModelId`:
   *
   * - `Identifier`:
   *
   * - `CustomerId`:
   */
  FieldAppOnboardDevice(params: FieldAppService.FieldAppOnboardDeviceParams): __Observable<Device> {
    return this.FieldAppOnboardDeviceResponse(params).pipe(
      __map(_r => _r.body as Device)
    );
  }

  /**
   * @param params The `FieldAppService.FieldAppGetAllSiteTypesWithActivityTypesParams` containing the following parameters:
   *
   * - `securityToken`:
   *
   * - `customerId`:
   */
  FieldAppGetAllSiteTypesWithActivityTypesResponse(params: FieldAppService.FieldAppGetAllSiteTypesWithActivityTypesParams): __Observable<__StrictHttpResponse<Array<SiteTypeWithActivityPlan>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.securityToken != null) __headers = __headers.set('securityToken', params.securityToken.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FieldApp/GetAllSiteTypesWithActivityTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteTypeWithActivityPlan>>;
      })
    );
  }
  /**
   * @param params The `FieldAppService.FieldAppGetAllSiteTypesWithActivityTypesParams` containing the following parameters:
   *
   * - `securityToken`:
   *
   * - `customerId`:
   */
  FieldAppGetAllSiteTypesWithActivityTypes(params: FieldAppService.FieldAppGetAllSiteTypesWithActivityTypesParams): __Observable<Array<SiteTypeWithActivityPlan>> {
    return this.FieldAppGetAllSiteTypesWithActivityTypesResponse(params).pipe(
      __map(_r => _r.body as Array<SiteTypeWithActivityPlan>)
    );
  }
}

module FieldAppService {

  /**
   * Parameters for FieldAppOnboardDevice
   */
  export interface FieldAppOnboardDeviceParams {
    securityToken?: null | string;
    PurchasedTime?: null | string;
    ManufacturerModelId?: number;
    Identifier?: null | string;
    CustomerId?: null | number;
  }

  /**
   * Parameters for FieldAppGetAllSiteTypesWithActivityTypes
   */
  export interface FieldAppGetAllSiteTypesWithActivityTypesParams {
    securityToken?: null | string;
    customerId?: number;
  }
}

export { FieldAppService }
